import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomeMain from './componenets/Home/HomeMain';
import AboutMain from './componenets/About/AboutMain';
import ContactMain from './componenets/Contact/ContactMain';
import HomeForm from './componenets/Test/HomeForm';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<div><HomeMain/></div>} />
        <Route path="/about" element={<div><AboutMain/></div>} />
        <Route path="/contact" element={<div><ContactMain/> </div>} />
        <Route path="/test" element={<div><HomeForm/> </div>} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;